import { BqApiProvider } from './../../providers/bq-api/bq-api';

import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController
} from "ionic-angular";
import { ToastController } from "ionic-angular";
import { TranslateService } from '@ngx-translate/core';

import { WelcomePage } from './../welcome/welcome';
import { NeedsDiagnosisPage } from './../needs-diagnosis/needs-diagnosis';


@IonicPage()
@Component({
  selector: 'page-contact-socket',
  templateUrl: 'contact-socket.html'
})
export class ContactSocketPage {
  public step3Answer: number;
  public step11Answer: number;

  public p12Selection: number;
  public p13Selection: number;
  public p14Selection: number;
  public p15Selection: number;
  public p16Selection: number;
  public p17Selection: number;
  public p18Selection: number;
  public p19Selection: number;

  public contactComment: string;

  constructor(
    private translate: TranslateService,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private bqApi: BqApiProvider
  ) {
    this.p12Selection = 0;
    this.p13Selection = 0;
    this.p14Selection = 0;
    this.p15Selection = 0;
    this.p16Selection = 0;
    this.p17Selection = 0;
    this.p18Selection = 0;
    this.p19Selection = 0;

    this.step11Answer = null;
    this.step3Answer = null;
  }

  ionViewDidLoad() {
    this.step3Answer = this.bqApi.getStep(3);
    this.step11Answer = this.bqApi.getStep(11);

    this.p12Selection = this.bqApi.getStep(12) || 0;
    this.p13Selection = this.bqApi.getStep(13) || 0;
    this.p14Selection = this.bqApi.getStep(14) || 0;
    this.p15Selection = this.bqApi.getStep(15) || 0;
    this.p16Selection = this.bqApi.getStep(16) || 0;
    this.p17Selection = this.bqApi.getStep(17) || 0;
    this.p18Selection = this.bqApi.getStep(18) || 0;
    this.p19Selection = this.bqApi.getStep(19) || 0;

    this.contactComment = this.bqApi.getComment(2) || '';
  }

  updateSteps(){
    if (this.p12Selection !== 0) {
      this.bqApi.setStep(12, this.p12Selection);
    }

    if (this.p13Selection !== 0) {
      this.bqApi.setStep(13, this.p13Selection);
    }

    if (this.p14Selection !== 0) {
      this.bqApi.setStep(14, this.p14Selection);
    }

    if (this.p15Selection !== 0) {
      this.bqApi.setStep(15, this.p15Selection);
    }

    if (this.p16Selection !== 0) {
      this.bqApi.setStep(16, this.p16Selection);
    }

    if (this.p17Selection !== 0) {
      this.bqApi.setStep(17, this.p17Selection);
    }

    if (this.p18Selection !== 0) {
      this.bqApi.setStep(18, this.p18Selection);
    }

    if (this.p19Selection !== 0) {
      this.bqApi.setStep(19, this.p19Selection);
    }

    if (this.contactComment !== '') {
      this.bqApi.setComment(2, this.contactComment);
    }

    this.bqApi.syncSteps();

  }

  nextStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(NeedsDiagnosisPage);
  }

  previousStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(WelcomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact-socket/contact-socket.ts